import styled from 'styled-components';

const StyledImage = styled.img`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default StyledImage;
